import { tap } from 'rxjs';
import { Action, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { Funnel } from '../../modules/funnel/models/funnel.model';
import { FunnelService } from '../../modules/funnel/services/funnel.service';
import { EntityActions as EA } from '../entity/entity.action';
import { Get } from './funding-manager-funnel.action';

/**
 * Manage FundingManagerFunnels in local store.
 */

export class FundingManagerFunnelStateModel {
	entities: Funnel[];
  current: Funnel | null;
  expires: number;
}

@State<FundingManagerFunnelStateModel>({
	name: 'fundingManagerFunnel',
	defaults: {
    entities: [],
    current: null,
    expires: 0
  }
})

@Injectable()
export class FundingManagerFunnelState {

  // When this store's data should expire.
  // Five minutes.
  private expiresIn: number = (5 * 60 * 1000);

	constructor(
    private funnelService: FunnelService
  ) {}

  @Action(Get)
	get(ctx: StateContext<FundingManagerFunnelStateModel>, payload: Get) {
    const state = ctx.getState();
    // ID of funding manager/lender user.
    const id = payload.id;

    // If already exists and not expired, return.
    const found = state.entities.find(e => e.id === id);
    if (found && state.expires > Date.now()) {
      ctx.patchState({
        current: found,
      });
      return;
    }

    // Return observable so nxgs auto-subscribes.
    // See https://www.ngxs.io/concepts/state#async-actions.
    return this.funnelService.getFundingManagerFunnel(id).pipe(
      tap(entity => {
        // Add to current list of entities in store.
        const entities = [...state.entities, entity];
        ctx.patchState({
          entities,
          expires: Date.now() + this.expiresIn,
          current: entity
        });
      })
    );
  }
}
